// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import {settingsSetItem, settingsGetItem} from '../../actions/settingsActions';
import { connect } from 'react-redux';
import AddEditForm from '../../components/settings/SettingsAddEditForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, commonConstants} from "../../constants";


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.settings.getItem,
        userValue: state.app.currentUser
    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getItem: (callback) => {
        dispatch(getItem(callback));
    },

    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(edit(value));
    },

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const edit = (values) => {

    let formData = {key_values : []};
    return (dispatch, getState) => {
        for(let i=0 ; i<values.length ; i++) {
            formData['key_values'].push({
                'const': values[i].const,
                'value': values[i].value,
            });
        }

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.put('setting', formData).then(editRes => {
            dispatch(settingsSetItem(editRes.data));
            if(editRes.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ویرایش'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

export const getItem = (callbakc) => {
    return (dispatch, getState) => {
        API_FETCH.get('setting').then(setting => {
            dispatch(settingsGetItem(setting.data));
            callbakc(true);
        }).catch(error => {
            console.log(error);
        });
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(AddEditForm);
